import { render, staticRenderFns } from "./PointsAdjustmentForm.vue?vue&type=template&id=3575f6e2&scoped=true"
import script from "./PointsAdjustmentForm.vue?vue&type=script&lang=js"
export * from "./PointsAdjustmentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3575f6e2",
  null
  
)

export default component.exports